// This component is popup which will open when we click on any game in the game list. It will show the setting of that particular game. It has two API calls, first one is to get the setting type of that game and second one is to get the data of that particular setting type. It also has a toggle button to change the status of that setting. It also has an update button to update the data of that setting.

import React, { useEffect, useState } from "react";
import { CommonModal } from "../../shared/Components/Modal";
import InputTable from "../../shared/Components/UI/InputTable";
import {
  getAxios,
  patchAxios,
  postAxios,
} from "../../shared/Services/commonService";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { SubHeading } from "../../shared/Components";
import {
  API_BETTINGTYPE_EVENTTYPE_ID,
  API_MARKET_SETTING,
} from "../../utils/api/ApiConstant";
import { useAccessControl } from "../../shared/Hooks/useAccessControl";

const MarketSettings = ({ rowData }) => {
  const queryClient = useQueryClient();
  const { hasPermission, isEditSetting } = useAccessControl();
  const [activeSettingType, setActiveSettingType] = useState(null);
  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    updateAll: false,
    name: "",
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
    handleUpdate: null,
  });
  console.log("🚀 rowData:", rowData);

  const eventTypeId = rowData?.eventTypeId;
  const marketId = rowData?.Id;
  // const marketId = rowData?.marketId;
  const marketName = rowData?.Name || "Market";

  console.log("marketId", marketId, marketName);

  // First API (Tournament settings for the selected tab)
  const { data: marketData, isLoading: marketLoading } = useQuery({
    queryKey: ["marketSettingData", marketId],
    queryFn: () =>
      getAxios(API_MARKET_SETTING, {
        marketId: marketId,
      }),
    enabled: !!marketId,
  });

  console.log("🚀 ~ marketData:", marketData);

  // Second API for updated settings
  const handleUpdate = async (row) => {
    const payload = {
      ...row,
      marketSettingId: row?.marketSettingId || null,
      marketId,
      bettingTypeId: activeSettingType,
    };

    const res = await postAxios(API_MARKET_SETTING, payload);

    if (res) {
      queryClient.invalidateQueries({
        queryKey: ["marketSettingData", marketId],
      });
    }
  };

  return (
    <>
      <SubHeading
        eyebrow="Game Settings"
        subTitle={`${marketName} Settings`}
        isAddBtn={true}
      />
      <div className="card-body">
        <div className="mt-3">
          {marketLoading ? (
            <p>Loading market settings...</p>
          ) : Array.isArray(marketData) && marketData.length > 0 ? (
            <InputTable
              tableData={marketData || []}
              onUpdate={handleUpdate}
              showUpdateAll={false}
              canUpdate={isEditSetting}
              handleModal={setIsShow}
            />
          ) : (
            <p>No market settings available.</p>
          )}
        </div>
      </div>

      {isShow.isOpen && (
        <CommonModal
          isShow={isShow.isOpen}
          // size={isShow.size}
          handleModalHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              rowData: {},
              name: "",
            }))
          }
          modalTitle={isShow.modalTitle}
          size={isShow.modalSize}
        >
          {isShow.modalContent &&
            React.createElement(isShow.modalContent, {
              handleShowHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  name: "",
                  modalTitle: "",
                })),
              rowData: isShow.rowData,
              updateAll: isShow.updateAll,
              isConfirmed: isShow.isConfirmed,
              handleFn: isShow.handleUpdate,
            })}
        </CommonModal>
      )}
    </>
  );
};

export default MarketSettings;
